import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import client from "../../api/client";

/**
 * Loads active FAQs from the backend. Pass `limit` to get only the first N
 * (the homepage uses 5). Re-fetches when the site language changes.
 */
export default function useFaqs({ limit } = {}) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").startsWith("fr") ? "fr" : "en";
  const [faqs, setFaqs] = useState([]);
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    client
      .get("/v2/faqs", { params: { lang, ...(limit ? { limit } : {}) } })
      .then((res) => {
        if (cancelled) return;
        setFaqs(Array.isArray(res.data?.data) ? res.data.data : []);
        setCategories(res.data?.categories || {});
      })
      .catch(() => !cancelled && setError(true))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [lang, limit]);

  return { faqs, categories, loading, error };
}
